module.exports = __webpack_public_path__ + "static/media/student-img-mob.85fbfb05.png";